import { render, staticRenderFns } from "./QuoteVersioning.vue?vue&type=template&id=52a98422&"
import script from "./QuoteVersioning.vue?vue&type=script&lang=js&"
export * from "./QuoteVersioning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports